var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemp1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 556,
    viewBox: "0 0 527 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1135_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 256.888V543C1 549.627 6.37258 555 13 555H514C520.627 555 526 549.627 526 543V13C526 6.37256 520.627 1 514 1H61.6364C55.0089 1 49.6364 6.37262 49.6364 13V198.385C49.6364 201.571 48.3691 204.627 46.114 206.878L4.52237 248.395C2.26725 250.646 1 253.701 1 256.888Z",
    fill: "#282828",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 256.888V543C1 549.627 6.37258 555 13 555H514C520.627 555 526 549.627 526 543V13C526 6.37256 520.627 1 514 1H61.6364C55.0089 1 49.6364 6.37262 49.6364 13V198.385C49.6364 201.571 48.3691 204.627 46.114 206.878L4.52237 248.395C2.26725 250.646 1 253.701 1 256.888Z",
    stroke: "white",
    strokeOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1135_468",
    x: -79.5,
    y: -79.5,
    width: 686,
    height: 715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1135_468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1135_468",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp1);
export default __webpack_public_path__ + "static/media/temp1.58422439d16b89ee3d7b01d0b35b9e60.svg";
export { ForwardRef as ReactComponent };